/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route_details__expense_note_section__edit__identity = /** @type {(inputs: {}) => string} */ () => {
	return `Antragsteller`
};

const en_route_details__expense_note_section__edit__identity = /** @type {(inputs: {}) => string} */ () => {
	return `Applicant's identity`
};

const es_route_details__expense_note_section__edit__identity = /** @type {(inputs: {}) => string} */ () => {
	return `Identidad del solicitante`
};

const fr_route_details__expense_note_section__edit__identity = /** @type {(inputs: {}) => string} */ () => {
	return `Identité du demandeur`
};

const it_route_details__expense_note_section__edit__identity = /** @type {(inputs: {}) => string} */ () => {
	return `Identità del richiedente`
};

const nl_route_details__expense_note_section__edit__identity = /** @type {(inputs: {}) => string} */ () => {
	return `Identiteit van de aanvrager`
};

const pt_route_details__expense_note_section__edit__identity = /** @type {(inputs: {}) => string} */ () => {
	return `Identidade do requerente`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__identity = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route_details__expense_note_section__edit__identity(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route_details__expense_note_section__edit__identity", locale)
	if (locale === "de") return de_route_details__expense_note_section__edit__identity(inputs)
	if (locale === "en") return en_route_details__expense_note_section__edit__identity(inputs)
	if (locale === "es") return es_route_details__expense_note_section__edit__identity(inputs)
	if (locale === "fr") return fr_route_details__expense_note_section__edit__identity(inputs)
	if (locale === "it") return it_route_details__expense_note_section__edit__identity(inputs)
	if (locale === "nl") return nl_route_details__expense_note_section__edit__identity(inputs)
	return pt_route_details__expense_note_section__edit__identity(inputs)
};